import React, { Component } from "react";
import { connect } from "react-redux";
import { Segment, Tab, Table, Image } from "semantic-ui-react";
import { parseString } from "xml2js";
import _ from "lodash";
import AppMenu from "../../components/pages/AppMenu";
import api from "../../api";
import settings from "../../settings";
import { expireSession } from "../../actions/auth";
import OfflineCriminalSearches from "./OfflineCriminalSearches";
import OfflineDriversLicenseSearches from "./OfflineDriversLicenseSearches";
import OfflineCivilSearches from "./OfflineCivilSearches";
import Check from "../../assets/images/check.gif";
import HourGlass from "../../assets/images/hourglass.png";
import PickUserForm from "../../components/forms/PickUserForm";
import { getErrorMessage } from "../messages/errorMessages";
import { getMySearchesBreadcrumb } from "../common/Breadcrumb";

class MyOfflineReports extends Component {
  state = {
    result: undefined,
    pickedUser: "",
  };
  componentDidMount() {
    this.loadData(this.props);
  }
  componentWillReceiveProps(nextProps) {
    this.loadData(nextProps);
  }

  loadData = (props) => {
    const pickedUser = this.state.pickedUser;
    const params = {
      view: "offline",
      month: new Date().getMonth() + 1,
      sserver: settings.appName,
      userID: props.user.userid,
      pickedUser,
      sessionID: localStorage.getItem("sessionID"),
    };

    api.lp.getActivitiesView(params).then((res) => {
      parseString(res.data, { async: false }, (err, result) => {
        const root = Object.keys(result)[0];
        if (root === "errors") {
          if (_.get(result, `${root}.error[0].$.errType`) === "unauthorized") {
            localStorage.errorMessage = _.get(
              result,
              `${root}.error[0].errMsg[0]`,
              ""
            );
            const errorMessage = getErrorMessage(
              localStorage.errorMessage,
              _.get(result, `${root}.error[0].errMsg[0]`, "")
            );
            this.props.expireSession(errorMessage);
          }
        } else {
          this.setState({ result, pickedUser });
        }
      });
    });
  };

  submit = (data) => {
    this.state.pickedUser = data.pickuser;
    this.loadData(this.props);
  };
  render() {
    const tabs = [];
    tabs.push({
      menuItem: `Offline Criminal Searches`,
      render: () => (
        <OfflineCriminalSearches
          pickedUser={this.state.pickedUser}
          {...this.props}
          data={this.state.result}
        />
      ),
    });

    tabs.push({
      menuItem: `Offline Civil Searches`,
      render: () => (
        <OfflineCivilSearches
          pickedUser={this.state.pickedUser}
          {...this.props}
          data={this.state.result}
        />
      ),
    });

    tabs.push({
      menuItem: `Offline Drivers License Searches`,
      render: () => (
        <OfflineDriversLicenseSearches
          pickedUser={this.state.pickedUser}
          {...this.props}
          data={this.state.result}
        />
      ),
    });

    return (
      <div className="container-fluid">
        <div className="padding-top-20" />
        <AppMenu
          uiData={this.props.uiData}
          userAccount={this.props.userAccount}
          history={this.props.history}
        />
        <div>
          <Segment className={"no-margin-top"}>
            {getMySearchesBreadcrumb({
              currentPage: settings.myAccountMenuItem.subMenuItems[2].MenuTitle,
              history: this.props.history,
            })}
            <br />

            <Table>
              <Table.Body>
                <Table.Row>
                  <Table.Cell>
                    <span className={"float-right icon-align-middle"}>
                      <Image
                        src={HourGlass}
                        inline
                        className={"icon-align-middle"}
                      />{" "}
                      Pending
                    </span>
                  </Table.Cell>
                  <Table.Cell>
                    <span className={"icon-align-middle"}>
                      <Image
                        src={Check}
                        inline
                        className={"icon-align-middle"}
                      />{" "}
                      Completed
                    </span>
                  </Table.Cell>
                </Table.Row>
                {this.props.userAccount.acctPickUser === "1" && (
                  <Table.Row>
                    <Table.Cell colSpan={2}>
                      <span className={"picked-user"}>{`UserName: ${
                        this.state.pickedUser
                          ? this.state.pickedUser
                          : this.props.user.userid
                      }`}</span>
                    </Table.Cell>
                  </Table.Row>
                )}
                {this.props.userAccount.acctPickUser === "1" && (
                  <Table.Row>
                    <Table.Cell colSpan={2}>
                      <PickUserForm submit={this.submit} />
                    </Table.Cell>
                  </Table.Row>
                )}
              </Table.Body>
            </Table>
            <Tab panes={tabs} className="margin-top-10" />
          </Segment>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state) {
  return {
    user: state.user,
    uiData: state.uiData,
    userAccount: state.userAccount,
  };
}

export default connect(mapStateToProps, { expireSession })(MyOfflineReports);



// WEBPACK FOOTER //
// ./src/components/myaccount/MyOfflineReports.js